
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea923"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea923"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $7e1f8850cd2474db$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["ioUUD","index.718c697b.js","3yDL4","cobblestone.25f8742f.webp","a62Uy","grass.85073952.webp","iFFbM","wood-floor.ef0b798a.webp","cydoX","forest-grass.2edc1389.webp","7L1XR","swamp-floor.b656f901.webp","cOvdK","stone-brick.1f3f8e2a.webp","40V45","rat.0710dbcc.webp","8R6Qk","rat-boss.266167ed.webp","j5sv4","goblin.16b663ca.webp","bC0Hi","goblet.2a7d512c.webp","3MJvg","ogre.befc24a7.webp","eGBrN","goblin-king.3397b392.webp","6NtQQ","thaddeus.7b3e576a.webp","157n4","door.dacf04e1.webp","lKQwm","cellar-door.b0bd5091.webp","2kEwv","castle-gate.514ee9a1.webp","ePuaj","cathedral.1aba4e48.webp","awKPr","tower.d2df14e8.webp","7glJd","shop.be7d439a.webp","bws7s","castle.cddd126d.webp","gdSsl","goblin-camp.6efcfb77.webp","dz4q1","witch-hut.83d807f8.webp","3LG6D","mirewood-tavern.4e13ed7a.webp","4BlYK","mirewood-house.80b3f809.webp","56IP5","guard.65a69fa4.webp","fw5RH","wizard-eldwin.9895eb70.webp","eeyp1","shopkeeper-cedric.dcf764b0.webp","2lek6","father-michael.44a10438.webp","ccSRx","king.e40a5e2a.webp","eE5nr","jester-jeffrey.596fd8bb.webp","dz8lb","witch.73ebae6b.webp","2XcZo","bookshelf.927aa83b.webp","iqn9I","altar.cbaf6e12.webp","cF0Xc","cauldron.34955e75.webp","8BOba","counter.eda3307e.webp","eQDOM","stained-glass-1.77a2dbe2.webp","5ffFb","stained-glass-2.c411fa5a.webp","hJhE9","stained-glass-3.e12caf5c.webp","bdqoI","stained-glass-4.f6308819.webp","zopni","throne.7f39d510.webp","62HAS","basilisk-statue.354071f9.webp","47Y3W","dragon-statue.69c47771.webp","4R3bR","tree.e431cf61.webp","5fGLZ","chest.a00a5c4b.webp","kKqsV","giant-tree.b3c678f7.webp","dHPsX","crown.5a3798ea.webp","7utIH","ogre-spray.756de276.webp","75NOQ","small-magic-potion.97cd17a4.webp","8WzGL","small-health-potion.bffb3fcc.webp","fYvyz","gold-coin.dabc275c.webp","5h9CN","index.e326c282.css"]'));


//# sourceMappingURL=index.runtime.3fc2c1ca.js.map
